import { ControlListDataTable } from "@/features/controls/components/control-list-data-table";
import { ControlListMainFilters } from "@/features/controls/components/control-list-main-filters";
import { ExportExcelPopoverContent } from "@/features/controls/components/export-excel-popover-content";
import { useControlListDataTableViewModel } from "@/features/controls/view-models/use-control-list-data-table.viewmodel";
import { useControlListViewModel } from "@/features/controls/view-models/use-control-list.viewmodel";
import { Button } from "@spz/ui/components/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@spz/ui/components/popover";
import { Typography } from "@spz/ui/components/typography";
import { useState } from "react";

export default function Controls() {
  const { t, selectedAnalysisId, hasExportReportPermission } =
    useControlListViewModel();

  const { table, uniqueTags, isLoading, currency } =
    useControlListDataTableViewModel({
      analysisId: selectedAnalysisId ?? "",
    });

  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center mb-2">
        <Typography variant="h5">{t("controls_list_title")}</Typography>
      </div>
      <div className="flex justify-between items-center">
        <ControlListMainFilters />
        {hasExportReportPermission && (
          <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
            <PopoverTrigger asChild>
              <Button variant="ghost" data-testid="control-list-export-button">
                {t("export_excel")}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="max-w-[300px]">
              <ExportExcelPopoverContent
                analysisId={selectedAnalysisId ?? ""}
                table={table}
                onClose={() => setPopoverOpen(false)}
              />
            </PopoverContent>
          </Popover>
        )}
      </div>

      {selectedAnalysisId && (
        <div className="mt-4">
          <ControlListDataTable
            table={table}
            uniqueTags={uniqueTags}
            isLoading={isLoading}
            currency={currency}
          />
        </div>
      )}
    </div>
  );
}
